<template lang="pug">
    v-card.elevation-1.px-1.py-2
        v-form( ref="form" v-model="valid" lazy-validation )
            v-layout( row wrap )
                v-flex( xs12 )
                    v-autocomplete( :items="optionsBranchOffice" v-bind="dataBranchOffice" v-model="selectedBranchOffice" )
                        div.formLabel( slot='prepend' ) Sucursal
                v-flex( xs12 )
                    v-divider.mb-4.pb-1
                v-flex( xs12 v-if="selectedBranchOffice" )
                    crud-data-table( :headers="headers" :service="service" @show="submitShowDataTable" :filters="filters" @select="selected = $event" checkable :editableFieldsOverwrites="testprop" ref="table")
                v-flex.pa-5( xs12 v-if="selected.length > 0" )
                    v-btn(
                        block=''
                        color='secondary'
                        dark
                        @click="submitSalePrices"
                        v-if="$can('EDIT_MASSIVE_PRODUCT_MARGIN_PRICE')"
                        ) Guardar precios de ventas
</template>

<script>
//
import { mapActions } from 'vuex'
//
//import CrudDataTable from '@/components/CrudDataTable/CrudDataTable'
import { CrudDataTable } from '@/components/reusable_components'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
//
import { BranchOfficeService } from '@/services/api'
import { getFetchDataFunction } from '@/services/api/DataTableService'
import FamilyService from '@/services/api/family/FamilyServices'
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
import ProductService from '@/services/api/product'

//
import ProductsSalePriceFilters from './filters'
import ProductsSalePriceHeaders, {
    filterByBranchOfficeId,
    reduceSalePrice,
    reduceGainsMargin,
} from './headers'

//
const route = process.env.VUE_APP_API_ROUTE + '/wh_product?g_branch_office_id=1'

//
const appends = ['branch_offices', 'sale_prices']

//
const includes = ['wh_item', 'wh_product_upc_code']

//
const format = branch_office_id => response => {
    //
    return {
        ...response,
        data: {
            ...response.data,
            data: response.data.data.map(product => {
                //
                return {
                    ...product,
                    virtual_sale_price: product.sale_prices
                        .filter(filterByBranchOfficeId(branch_office_id))
                        .reduce(reduceSalePrice, 0),
                }
            }),
        },
    }
}

//
export default {
    name: 'product-sale-price-list',
    data() {
        return {
            /**
             *
             */
            dataBranchOffice: {
                'item-text': 'name',
                'item-value': 'id',
                placeholder: 'Seleccione parámetros a buscar',
                'single-line': true,
                outline: true,
            },

            /**
             *
             */
            filters: ProductsSalePriceFilters || [],

            /**
             *
             */
            optionsBranchOffice: [],

            /**
             *
             */
            selectedBranchOffice: null,

            /**
             *
             */
            service: {
                dtFetchData: getFetchDataFunction(
                    route,
                    includes,
                    appends,
                    format(1)
                ),
            },

            selected: [],

            /**
             *
             */
            generalDiscount: '',

            /**
             *
             */
            testprop: [
                {
                    field: 'sale_prices',
                    value: 0,
                    condition: row => {
                        if (row.sale_prices === null) return true
                        return false
                    },
                },
            ],

            /**
             *
             */
            headers: ProductsSalePriceHeaders(1),

            valid: true,
            rules: [v => !!v || 'Campo requerido'],
            showTable: false,
            offerName: null,
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        hasSelectedBranchOffice() {
            return !!this.selectedBranchOffice
        },

        /**
         *
         */
        mapSelectedToMassiveMarginProducts: branch_office_id => ({
            id,
            sale_prices,
            virtual_sale_price,
        }) => ({
            wh_product_id: id,
            gains_margin: sale_prices
                .filter(filterByBranchOfficeId(branch_office_id))
                .reduce(reduceGainsMargin, 0),
            sale_price: virtual_sale_price,
        }),

        /**
         *
         */
        reduceBranchOfficeToSalePrice: ({ sale_price }) => sale_price,
        /**
         *
         */
        reduceFamilyToFilterOptions: data => ({
            text: data.family,
            value: data.id,
        }),

        /**
         *
         */
        reduceSubFamilyToFilterOptions: data => ({
            text: data.subfamily,
            value: data.id,
        }),

        /**
         *
         */
        async refresh() {
            //
            //this.$router.go(
            window.location.replace(window.location.href)
        },

        /**
         *
         */
        setBranchOfficeOptions(options = []) {
            this.optionsBranchOffice = options
        },

        /**
         *
         */
        setFilterOptions(index, options = []) {
            this.filters[index].options = options
        },

        /**
         *
         */
        setHeaders(headers) {
            //
            this.headers = headers
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback = () => {}) {
            //
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))

            //
            callback()
        },

        /**
         *
         */
        submitShowDataTable($event) {
            //
            return this.$router.push('/products/' + $event)
        },

        /**
         *
         */
        async submitSalePrices() {
            //
            var snackInfo = {}

            //
            const g_branch_office_id = this.selectedBranchOffice,
                products = this.selected.map(
                    this.mapSelectedToMassiveMarginProducts(g_branch_office_id)
                )

            //
            const payload = {
                g_branch_office_id,
                products,
            }

            //
            const response = await ProductService.massiveUpdateSalePrices(
                payload
            )

            //
            switch (response.status) {
                case 'success':
                    this.resetSnackbarState()
                    this.$refs.table.toggleAll()
                    this.$refs.table.toggleAll()
                    this.$refs.table.checkAndFetch()
                    return this.showSnackbar(
                        'success',
                        'Éxito',
                        'Los precios de venta fueron actualizados correctamente.',
                        this.refresh
                    )
                case 'error':
                    this.resetSnackbarState()
                    return this.showSnackbar('error', 'Error', response)
            }
        },
    },
    watch: {
        /**
         *
         */
        selectedBranchOffice(value) {
            this.setHeaders(ProductsSalePriceHeaders(value))
        },
    },
    components: {
        'crud-data-table': CrudDataTable,
    },
    mixins: [CurrencyUtils],
    async beforeMount() {
        //
        const dataBranchOffice = await BranchOfficeService.fetchAll(),
            dataFamily = await FamilyService.fetchAllFamily(),
            dataSubFamily = await SubfamilyService.fetchAllSubfamily(),
            optionsFamily = dataFamily.map(this.reduceFamilyToFilterOptions),
            optionsSubFamily = dataSubFamily.map(
                this.reduceSubFamilyToFilterOptions
            )

        //
        this.setBranchOfficeOptions(dataBranchOffice)
        this.setFilterOptions(1, optionsFamily)
        this.setFilterOptions(2, optionsSubFamily)
    },
    async mounted() {
        //
        this.setTitleTopBar('Modificar precios de venta')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('EDIT_MASSIVE_PRODUCT_MARGIN_PRICE'))
                ctx.$router.push('/')
        })
    },
}
</script>
